(function ($) {
    $.fn.select2entity = function (options) {
        this.each(function () {
            let request;

            // Keep a reference to the element so we can keep the cache local to this instance and so we can
            // fetch config settings since select2 doesn't expose its options to the transport method.
            let $s2 = $(this),
                limit = $s2.data('page-limit') || 0,
                scroll = $s2.data('scroll'),
                scrollEnabled = scroll === true || scroll === 'true' || scroll === 1 || scroll === '1',
                prefix = Date.now(),
                query_parameters = $s2.data('query-parameters'),
                render_html = $s2.data('render-html'),
                cache = [];

            let reqParams = $s2.data('req_params');

            if (reqParams) {
                reqParams = JSON.parse(decodeURIComponent(reqParams));
                $.each(reqParams, function (key, value) {

                    $('*[name="' + value + '"]').on('change', function () {
                        $s2.val(null);
                        $s2.trigger('change');
                    });
                });
            }

            // Deep-merge the options
            let mergedOptions = $.extend(true, {
                // Tags support
                createTag: function (data) {
                    if ($s2.data('tags') && data.term.length > 0) {
                        let text = data.term + $s2.data('tags-text');
                        return { id: $s2.data('new-tag-prefix') + data.term, text: text };
                    }
                },
                ajax: {
                    url: $s2.data('ajax--url') || null,
                    transport: function (params, success, failure) {
                        // is caching enabled?
                        if ($s2.data('ajax--cache')) {
                            // try to make the key unique to make it less likely for a page+q to match a real query
                            var key = prefix + ' page:' + (params.data.page || 1) + ' ' + params.data.q,
                                cacheTimeout = $s2.data('ajax--cacheTimeout');
                            // no cache entry for 'term' or the cache has timed out?
                            if (typeof cache[key] === 'undefined' || (cacheTimeout && Date.now() >= cache[key].time)) {
                                return $.ajax(params).fail(failure).done(function (data) {
                                    cache[key] = {
                                        data: data,
                                        time: cacheTimeout ? Date.now() + cacheTimeout : null
                                    };
                                    success(data);
                                });
                            } else {
                                // return cached data with no ajax request
                                success(cache[key].data);
                            }
                        } else {
                            // no caching enabled. just do the ajax request
                            if (request) {
                                request.abort();
                            }
                            request = $.ajax(params).fail(failure).done(success).always(function () {
                                request = undefined;
                            });

                            return request;
                        }
                    },
                    data: function (params) {
                        let ret = {
                            'q': params.term,
                            'field_name': $s2.data('name'),
                            'class_type': $s2.data('classtype')
                        };

                        let reqParams = $s2.data('req_params');
                        if (reqParams) {
                            reqParams = JSON.parse(decodeURIComponent(reqParams));
                            $.each(reqParams, function (key, value) {
                                ret[key] = $('*[name="' + value + '"]').val();
                            });
                        }

                        if (scrollEnabled) {
                            ret['page'] = params.page || 1;
                        }

                        if (limit) {
                            ret['limit'] = limit;
                        }

                        if (Array.isArray(query_parameters) ||
                            typeof (query_parameters) === 'object') {
                            for (var key in query_parameters) {
                                // prevent overriding required parameters
                                if (!ret[key]) {
                                    ret[key] = query_parameters[key];
                                }
                            }
                        }

                        return ret;
                    },
                    processResults: function (data, params) {

                        let results, more = false,
                            response = {};
                        params.page = params.page || 1;

                        if ($.isArray(data)) {
                            results = data;
                        } else if (typeof data === 'object') {
                            // assume remote result was proper object
                            results = data.results;
                            more = data.more;
                        } else {
                            // failsafe
                            results = [];
                        }

                        if (scrollEnabled) {
                            response.pagination = { more: !!more };
                        }
                        response.results = results;
                        return response;
                    }
                }
            }, options || {});
            if (render_html) {
                mergedOptions = $.extend({
                    escapeMarkup: function (text) {
                        return text;
                    },
                    templateResult: function (option) {
                        return option.html ? option.html : option.text;
                    },
                    templateSelection: function (option) {
                        return option.text;
                    }
                }, mergedOptions);
            }

            mergedOptions = $.extend({
                theme: 'bootstrap4',
                allowClear: $s2.data('allow-clear') === true || $s2.data('allow-clear') === 'true',
                placeholder: $s2.data('placeholder') || '',
            }, mergedOptions);

            if (scrollEnabled && mergedOptions.ajax) {
                mergedOptions.ajax.delay = mergedOptions.ajax.delay ?? 250;
            }

            $s2.select2(mergedOptions);
            bindSelect2ClearAll($s2);
        });
        return this;
    };

    function bindSelect2ClearAll($s2) {
        if (!$s2.prop('multiple')) {
            return;
        }

        const container = $s2.next('.select2-container')[0];
        if (!container) {
            return;
        }

        let button = container.nextElementSibling;
        if (!button || !button.classList.contains('select2-clear-all')) {
            button = document.createElement('button');
            button.type = 'button';
            button.className = 'select2-clear-all';
            button.textContent = 'изтрий всички';
            button.addEventListener('click', (event) => {
                event.preventDefault();
                event.stopPropagation();
                $s2.val(null).trigger('change');
            });
            container.insertAdjacentElement('afterend', button);
        }

        const updateVisibility = () => {
            const value = $s2.val();
            const selectedCount = $s2.find('option:selected').filter((_, option) => option.value !== '').length;
            const hasValue = selectedCount > 0 || (Array.isArray(value) ? value.length > 0 : Boolean(value));
            button.hidden = !hasValue;
        };

        $s2.off('change.select2clearall select2:select.select2clearall select2:unselect.select2clearall');
        $s2.on('change.select2clearall select2:select.select2clearall select2:unselect.select2clearall', updateVisibility);
        updateVisibility();
    }
})(jQuery);

(function ($) {
    $(document).ready(function () {
        $('.select2entity[data-autostart="true"]').select2entity();
    });
})(jQuery);
